import {
	ClaimSolutionEnum,
	ClaimStatusEnum,
	ClaimTypeEnum,
} from "Infrastructure/Api/Api";
import type {
	ClaimSelectOptions,
	ClaimShared,
	ClaimsList,
	ClaimsMutations,
	ClaimsTabs,
	ClaimTable,
	ClaimTranslations,
} from "Infrastructure/Translation/Types/claim";

const claimsListTranslations: ClaimsList = {
	title: "Claims",
	description: "List of claims",
};

const claimsTabsTranslations: ClaimsTabs = {
	tabTitle: "Claim",
	addNew: "Add new claim",
};

const claimsMutationsTranslations: ClaimsMutations = {
	claimCreateError: "Failed to create claim",
	claimCreateSuccess: "Claim created successfully",
	claimUpdateError: "Failed to update claim",
	claimUpdateSuccess: "Claim updated successfully",
};

export const claimTableTranslations: ClaimTable = {
	id: "ID",
	orderId: "Order ID",
	partner: "Partner",
	customer: "Customer",
	status: "Status",
	type: "Type",
	fee: "Fee",
	description: "Description",
	finalSolution: "Final solution",
	dateNextAction: "Next action date",
	dateCreated: "Date created",
	dateUpdated: "Date updated",
	dateResolved: "Date resolved",
};

const claimSharedTranslations: ClaimShared = {
	actions: "Actions",
	createClaimHeading: "Create claim",
	editClaimHeading: "Edit claim",
	created: "Created",
};

const selectOptionsTranslations: ClaimSelectOptions = {
	claimStatus: {
		[ClaimStatusEnum.active]: "Active",
		[ClaimStatusEnum.resolved]: "Resolved",
	},
	claimType: {
		[ClaimTypeEnum.cleaning]: "Cleaning",
		[ClaimTypeEnum.communication]: "Communication",
		[ClaimTypeEnum.our_service]: "Our Service",
		[ClaimTypeEnum.price_change]: "Price Change",
		[ClaimTypeEnum.quality]: "Quality",
		[ClaimTypeEnum.time_management]: "Time Management",
	},
	claimSolution: {
		[ClaimSolutionEnum.original_partner]: "Original Partner",
		[ClaimSolutionEnum.discount]: "Discount",
		[ClaimSolutionEnum.replace_partner]: "Replace Partner",
		[ClaimSolutionEnum.replace_partner_with_discount]:
			"Replace Partner with Discount",
	},
};

export const claimTranslations: ClaimTranslations = {
	claimsList: claimsListTranslations,
	claimsTabs: claimsTabsTranslations,
	claimsMutations: claimsMutationsTranslations,
	claimTable: claimTableTranslations,
	claimShared: claimSharedTranslations,
	claimSelectOptions: selectOptionsTranslations,
};
